import { Helmet } from "react-helmet";

const Seo = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Bayka Berlin GmbH" />
      <meta httpEquiv="content-language" content="de" />
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default Seo;
